import { ReactNode } from 'react'
import { Icon, Dropdown, Tooltip, Button } from 'mk-pc'
import { useAppNavigate, useUser } from '@mkmp/core'
import { NavAuth } from '@/components'
import { useAuth } from '@/hooks'
import DefaultHeader from '@/assets/images/default-header.png'
import './index.scss'

interface Props {
  rightElement?: ReactNode
}

/**
 * 首页头部
 * @returns
 */
export const Header = ({ rightElement }: Props) => {
  const user = useUser()
  const navigate = useAppNavigate()
  const { userLogout } = useAuth()

  /**
   * 退出
   */
  const handleLogout = async () => {
    await userLogout()

    window.location.replace('/login')
  }

  /**
   * 跳转审核中心
   */
  const toAudit = () => {
    navigate(`/audit`, {
      appName: 'kbsApp',
      appBaseRoute: '/kbs/'
    })
  }

  /**
   * 去上传分享
   */
  const toUploader = () => {
    navigate('/uploader', {
      appName: 'kbsApp',
      appBaseRoute: '/kbs/'
    })
  }

  /**
   * 到主页
   */
  const toHome = () => {
    navigate('/cloud/plan', {
      appName: 'kbsApp',
      appBaseRoute: '/kbs/'
    })
  }

  return (
    <header className="message-header">
      <div className="message-header__content">
        <span className="logo" onClick={toHome}></span>
        <div className="right">
          <Button className="share-btn" onClick={toUploader}>
            <Icon name="icon-fenxiang" />
            我要分享
          </Button>
          <ul className="btns">
            <NavAuth navCode="audit">
              <li onClick={toAudit}>
                <Tooltip placement="top" title={'审核中心'} arrow={true}>
                  <Icon name="icon-SQLshenhe" />
                </Tooltip>
              </li>
            </NavAuth>
            <li>
              <Tooltip placement="top" title={'消息通知'} arrow={true}>
                <Icon name="icon-tongzhi" />
              </Tooltip>
            </li>
          </ul>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  label: (
                    <div className="user-menu-item" onClick={handleLogout}>
                      <Icon name="icon-tuichu" size="16" /> 退出
                    </div>
                  )
                }
              ]
            }}
          >
            <div className="user">
              <div className="avatar">
                <img src={DefaultHeader} />
              </div>
              <span className="name">{user && user.name}</span>
            </div>
          </Dropdown>
        </div>
      </div>
      <div className="message-header__category">
        <ul>
          <li className="active">系统通知</li>
        </ul>
      </div>
    </header>
  )
}
